var _rect, _path, _circle, _rect2, _circle2, _rect3, _path2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactShapes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1291,
    height: 719,
    viewBox: "0 0 1291 719",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1136.59,
    y: 42.2793,
    width: 107.204,
    height: 24.699,
    transform: "rotate(-23.1765 1136.59 42.2793)",
    fill: "#7F8CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1282.7 72.8419C1277.73 64.0178 1270.75 56.4883 1262.32 50.8631C1253.9 45.2379 1244.27 41.6752 1234.22 40.4634C1224.16 39.2515 1213.96 40.4247 1204.45 43.8878C1194.93 47.351 1186.36 53.0067 1179.43 60.3972C1172.51 67.7877 1167.42 76.7051 1164.58 86.4275C1161.75 96.1498 1161.24 106.404 1163.1 116.359C1164.96 126.315 1169.14 135.692 1175.3 143.731C1181.46 151.77 1189.43 158.246 1198.56 162.633L1210.58 137.618C1205.38 135.119 1200.84 131.43 1197.33 126.85C1193.82 122.27 1191.44 116.928 1190.38 111.256C1189.32 105.585 1189.61 99.7429 1191.23 94.2041C1192.84 88.6653 1195.74 83.585 1199.69 79.3747C1203.63 75.1643 1208.51 71.9423 1213.94 69.9693C1219.36 67.9964 1225.17 67.328 1230.9 68.0184C1236.63 68.7088 1242.11 70.7385 1246.91 73.9431C1251.71 77.1478 1255.68 81.4373 1258.51 86.4644L1282.7 72.8419Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 408.5,
    cy: 48.5,
    r: 13.5,
    fill: "#7F8CFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 117.53,
    height: 21.0255,
    transform: "matrix(0.801365 0.598176 0.598176 -0.801365 8.85742 276.606)",
    fill: "#7F8CFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1975,
    cy: 328.03,
    r: 24,
    transform: "rotate(48.9435 34.1975 328.03)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 684.347,
    width: 55.6001,
    height: 9.94658,
    transform: "rotate(-23.6989 262 684.347)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291.13 683.682C288.986 688.704 288.925 694.372 290.959 699.439C292.994 704.506 296.959 708.558 301.981 710.702C307.002 712.846 312.67 712.907 317.737 710.872C322.805 708.837 326.856 704.873 329 699.851L291.13 683.682Z",
    fill: "#7F8CFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1091.5,
    cy: 479.5,
    r: 37.5,
    fill: "#7F8CFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactShapes);
export default __webpack_public_path__ + "static/media/contact-shapes.e170950d741461ccf60a0cc8643b87af.svg";
export { ForwardRef as ReactComponent };